import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../axios";

const initialState = {
  cardsData: null,
  cardsLoading: false,
  clinicList: [],
  clinicListLoading: false,
  patientList: [],
  patientListLoading: false,
  averageScoreTrendData: null,
  averageScoreTrendLoading: false,
  totalAssessmentsData: null,
  totalAssessmentsLoading: false,
  severityDistributionData: null,
  severityDistributionLoading: false,
  patientLevelList: null,
  patientLevelListLoading: false,
  patientDetailData: null,
  patientDetailLoading: false,
  patientInfoData: null,
  patientInfoLoading: false,
  phase2Data: null,
  phase2Loading: false,
};

export const fetchAnalyticsCardsLogic = createAsyncThunk(
  "analytics/cards",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/analytics/cards`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchClinicListLogic = createAsyncThunk(
  "analytics/clinicList",
  (params) => {
    return axiosInstance.get("/api/clinics-list", {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      params: params,
    });
  }
);

export const fetchPatientListLogic = createAsyncThunk(
  "analytics/patientList",
  (params) => {
    return axiosInstance.get("/api/patients-list", {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      params: params,
    });
  }
);

export const fetchAverageScoreTrendLogic = createAsyncThunk(
  "analytics/averageScoreTrend",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/analytics/charts/average-score-trend`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchTotalAssessmentsLogic = createAsyncThunk(
  "analytics/totalAssessments",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/analytics/charts/total-assessments`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchSeverityDistributionLogic = createAsyncThunk(
  "analytics/severityDistribution",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/analytics/charts/severity-distribution`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchPatientLevelListLogic = createAsyncThunk(
  "analytics/patientLevelList",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/analytics/patient-list`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchPatientInfoLogic = createAsyncThunk(
  "analytics/patientInfo",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/analytics/cards/patient-info/`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchPatientDetailLogic = createAsyncThunk(
  "analytics/patientDetail",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/analytics/patient-detail`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    });
  }
);

export const fetchAnalyticsPhase2Logic = createAsyncThunk(
  "analytics/phase2",
  (payload) => {
    return axiosInstance.request({
      method: "post",
      url: `/api/analytics/phase2/`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    });
  }
);

const analyticsAPICalls = {
  [fetchAnalyticsCardsLogic.pending]: (state) => {
    state.cardsLoading = true;
  },
  [fetchAnalyticsCardsLogic.fulfilled]: (state, { payload }) => {
    console.log("Analytics Cards response:", payload.data);
    state.cardsData = payload.data;
    state.cardsLoading = false;
  },
  [fetchAnalyticsCardsLogic.rejected]: (state) => {
    state.cardsLoading = false;
  },

  [fetchClinicListLogic.pending]: (state) => {
    state.clinicListLoading = true;
  },
  [fetchClinicListLogic.fulfilled]: (state, { payload }) => {
    console.log("Clinic List response:", payload.data);
    state.clinicList = payload.data;
    state.clinicListLoading = false;
  },
  [fetchClinicListLogic.rejected]: (state) => {
    state.clinicListLoading = false;
  },

  [fetchPatientListLogic.pending]: (state) => {
    state.patientListLoading = true;
  },
  [fetchPatientListLogic.fulfilled]: (state, { payload }) => {
    console.log("Patient List response:", payload.data);
    state.patientList = payload.data;
    state.patientListLoading = false;
  },
  [fetchPatientListLogic.rejected]: (state) => {
    state.patientListLoading = false;
  },

  [fetchAverageScoreTrendLogic.pending]: (state) => {
    state.averageScoreTrendLoading = true;
  },
  [fetchAverageScoreTrendLogic.fulfilled]: (state, { payload }) => {
    console.log("Average Score Trend response:", payload.data);
    state.averageScoreTrendData = payload.data;
    state.averageScoreTrendLoading = false;
  },
  [fetchAverageScoreTrendLogic.rejected]: (state) => {
    state.averageScoreTrendLoading = false;
  },

  [fetchTotalAssessmentsLogic.pending]: (state) => {
    state.totalAssessmentsLoading = true;
  },
  [fetchTotalAssessmentsLogic.fulfilled]: (state, { payload }) => {
    console.log("Total Assessments response:", payload.data);
    state.totalAssessmentsData = payload.data;
    state.totalAssessmentsLoading = false;
  },
  [fetchTotalAssessmentsLogic.rejected]: (state) => {
    state.totalAssessmentsLoading = false;
  },

  [fetchSeverityDistributionLogic.pending]: (state) => {
    state.severityDistributionLoading = true;
  },
  [fetchSeverityDistributionLogic.fulfilled]: (state, { payload }) => {
    console.log("Severity Distribution response:", payload.data);
    state.severityDistributionData = payload.data;
    state.severityDistributionLoading = false;
  },
  [fetchSeverityDistributionLogic.rejected]: (state) => {
    state.severityDistributionLoading = false;
  },

  [fetchPatientLevelListLogic.pending]: (state) => {
    state.patientLevelListLoading = true;
  },
  [fetchPatientLevelListLogic.fulfilled]: (state, { payload }) => {
    state.patientLevelList = payload.data;
    state.patientLevelListLoading = false;
  },
  [fetchPatientLevelListLogic.rejected]: (state) => {
    state.patientLevelListLoading = false;
  },

  [fetchPatientDetailLogic.pending]: (state) => {
    state.patientDetailLoading = true;
  },
  [fetchPatientDetailLogic.fulfilled]: (state, { payload }) => {
    state.patientDetailData = payload.data;
    state.patientDetailLoading = false;
  },
  [fetchPatientDetailLogic.rejected]: (state) => {
    state.patientDetailLoading = false;
  },

  [fetchPatientInfoLogic.pending]: (state) => {
    state.patientInfoLoading = true;
  },
  [fetchPatientInfoLogic.fulfilled]: (state, { payload }) => {
    console.log("PatientInfo response:", payload.data);
    state.patientInfoData = payload.data;
    state.patientInfoLoading = false;
  },
  [fetchPatientInfoLogic.rejected]: (state) => {
    state.patientInfoLoading = false;
  },
  [fetchAnalyticsPhase2Logic.pending]: (state) => {
    state.phase2Loading = true;
  },
  [fetchAnalyticsPhase2Logic.fulfilled]: (state, { payload }) => {
    console.log("Analytics Phase 2 response:", payload.data);
    state.phase2Data = payload.data;
    state.phase2Loading = false;
  },
  [fetchAnalyticsPhase2Logic.rejected]: (state) => {
    state.phase2Loading = false;
  },
};

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  extraReducers: {
    ...analyticsAPICalls,
  },
  reducers: {
    resetAnalyticsState: () => initialState,
    clearPatientList: (state) => {
      state.patientList = [];
      state.patientListLoading = false;
    },
    clearPatientDetail: (state) => {
      state.patientDetailData = null;
      state.patientDetailLoading = false;
    },
    clearPatientInfo: (state) => {
      state.patientInfoData = null;
      state.patientInfoLoading = false;
    },
  },
});

export const { resetAnalyticsState, clearPatientList, clearPatientDetail, clearPatientInfo } = analyticsSlice.actions;
export default analyticsSlice.reducer;
